<ng-container *ngFor="let error of errors">
	<div
		*ngIf="error.trigger"
		[attr.data-cy]="'error-' + error.id"
		class="invalid-feedback"
		[innerHTML]="error.text"
	></div>
</ng-container>
